import { css } from '@emotion/core';

export const globals = css`
  html, body, h1, h2, h3, h4, p {
    font-family: 'Ubuntu', sans-serif !important;
  }
}`;
